export interface ApiClientOptions { 
  method?: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
  body?: any;
  headers?: Record<string, string>;
}

const API_BASE_URL = "https://v3.televet-api.a2zhealth.in/";
const API_KEY = "bXaljR3Sd1Jy4oG0QGOiLRwIEpCzR13r";

async function apiClient<T>(
  endpoint: string,
  options: ApiClientOptions = {}
): Promise<T> {
  const { method = "GET", body, headers = {} } = options;
  const token = sessionStorage.getItem("token"); // <-- changed to sessionStorage

  const config: RequestInit = {
    method,
    headers: {
      "Content-Type": "application/json",
      "x-api-key": API_KEY,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...headers,
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  };

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);

    if (response.status === 401) {
      const unauthorizedError = {
        code: 401,
        message: "Unauthorized",
        data: {},
      };


      return Promise.reject(unauthorizedError);
    }

    // Handle other non-OK responses
    if (!response.ok) {
      let errorMessage = `API error: ${response.status}`;

      try {
        const errorData = await response.json();
        errorMessage = errorData.message || errorMessage;

        // Handle expired token specifically
        if (errorMessage === "Expired token") {
          window.location.href = "/";
          return Promise.reject({
            code: response.status,
            message: errorMessage,
            data: {},
          });
        }

        return Promise.reject({
          code: response.status,
          message: errorMessage,
          data: errorData?.data || {},
        });
      } catch {
        return Promise.reject({
          code: response.status,
          message: errorMessage,
          data: {},
        });
      }
    }

    // Handle no content
    if (response.status === 204) {
      return {} as T;
    }

    // Successful response
    const data: T = await response.json();
    return data;
  } catch (error: any) {
    return Promise.reject({
      code: 500,
      message: error.message || "Unexpected error occurred",
      data: {},
    });
  }
}

export default apiClient;
